if (Shopify.designMode) {
  // For theme editor
  document.addEventListener('shopify:section:load', initVideoAutoplay);
}
document.addEventListener('DOMContentLoaded', initVideoAutoplay);

function initVideoAutoplay() {
  setTimeout(function() {
    const cards = document.querySelectorAll('.card__inner');
    
    cards.forEach(function(card) {
      const deferredMedia = card.querySelector('deferred-media');
      const poster = card.querySelector('.deferred-media__poster');
      
      if (deferredMedia && poster) {
        // Simulate click on poster to load video
        poster.click();
        
        setTimeout(function() {
          const video = card.querySelector('video');
          if (video) {
            video.muted = true;
            video.loop = true;
            video.play();
          }
        }, 200);
      }
    });
  }, 1000);
}
